import { FlexBox } from '@dixa/lib-shared-habla';
import { ArticlesViewTable } from 'collection/pages/articles/components/articlesTable';
import { useSetAtom } from 'jotai';
import { useArticlesQuery } from 'lib-knowledge-management-common/graphql';
import Page from 'lib-knowledge-utils/components/page/index';
import { collectionIdAtom } from 'models/collectionStore';
import { useEffect } from 'react';

import { CollectionManagementNav } from '../collectionEdit/components/layout/layout';
import { ArticlesFilters } from './components/articlesFilters';

export type UseArticlesQueryParams = Parameters<typeof useArticlesQuery>[0];

export function ArticlesPage(): JSX.Element {
  const setCollectionId = useSetAtom(collectionIdAtom);
  useEffect(() => {
    setCollectionId(undefined); // clear collectionId when the page is loaded
  }, [setCollectionId]);

  return (
    <>
      <Page>
        <Page.Body flexDirection="row">
          <CollectionManagementNav />
          <FlexBox flexDirection="column" width="100%">
            <Page.Head
              slotLeft={<Page.HeadTitle title="All articles" />}
              slotRight={<ArticlesFilters />}
            />
            <ArticlesViewTable />
          </FlexBox>
        </Page.Body>
      </Page>
    </>
  );
}
